import Model from '@/models/Model.js';

export default class SurveyActivity extends Model {
    static entity = 'survey_activities';

    static modelName = 'SurveyActivity';

    static fields() {
        return {
            id: this.attr(null),
            content_template_id: this.attr(null),
            content: this.attr(null),
            time_limit: this.attr(null),
            lockdown: this.attr(null),
            quiz_version_id: this.attr(null),

            survey: this.belongsTo('surveys', 'quiz_version_id'),
        };
    }
}
